import React, { useState } from 'react';
import { loginUser } from '../services/authService';
import { getDisplayErrorMessage } from '../services/apiError';
import { useNavigate, Link } from 'react-router-dom';
import ErrorMessage from './ErrorMessage';

const LoginForm = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({
    email: '',
    password: ''
  });
  const [successMessage, setSuccessMessage] = useState(null); 
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    
    setError(null);
    setErrors({});
    setSuccessMessage(null);
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validationErrors = {};

    if (email.trim() === "" || !emailRegex.test(email)) {
        validationErrors.email = "Invalid email";
    }
    
    if (password.trim() === "" || password.length < 8) {
        validationErrors.password = "Password must contain at least 8 characters";    
    }

    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
    }
    
    setIsLoading(true);

    try {
      const response = await loginUser(email, password);
      setSuccessMessage("Success!");
      console.log(response);

      onLoginSuccess();
      navigate("/");

      setEmail('');
      setPassword('');
    } catch (err) {
      setError(getDisplayErrorMessage(err));
    } finally {
      setIsLoading(false);
    }
  };
  
  const validateField = (name, value) => {
    let error = "";
    
    if (name === "email") {
      if (value.trim() === "") {
        error = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = "Invalid email format";
      }
    } else if (name === 'password') {
      if (value.length < 8) {
        error = "Password must contain at least 8 characters";
      }
    }

    setErrors(prev => ({ ...prev, [name]: error }));
  };

  return (
    <div className="h-[calc(100vh-64px)] flex items-center justify-center bg-gray-100">
      <div className="bg-gray-200 mx-auto w-full max-w-lg rounded shadow-md py-6 relative">
        <ErrorMessage message={error} onDismiss={() => setError(null)} />
        {successMessage && (
          <div className="w-full bg-green-100 text-green-500 text-center absolute shadow-2xl p-4 py-8 border-green-400 border-[1px] rounded-xl top-10 right-auto left-auto">
            {successMessage}
          </div>
        )}
        <form className="bg-gray-300 rounded px-32 pt-6 pb-8 my-4 flex flex-col shadow-lg" onSubmit={ handleSubmit }>
          <div className="mb-4">
            <input 
              placeholder="Enter email" 
              type="email" 
              className="w-full rounded p-1" 
              value={ email } 
              onChange={ (e) => setEmail(e.target.value) }
              onBlur={ (e) => validateField('email', e.target.value)}
            />
            {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
          </div>

          <div className="mb-6">
            <input 
              placeholder="Enter password" 
              type="password" 
              className="w-full rounded p-1" 
              value={ password } 
              onChange={ (e) => setPassword(e.target.value) }
              onBlur={ (e) => validateField('password', e.target.value)}
            />
            {errors.password && <p className="text-red-500 text-xs">{errors.password}</p>}
          </div>
          <button
            disabled={ isLoading }
            type="submit" className="bg-gray-200 rounded p-2 hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Processing...' : 'Login'}
          </button>
        </form>
        <div className="text-center">If you don't have an account, <Link to="/register" className="hover:underline text-blue-500">register here</Link></div>
      </div>
    </div>
  );
};

export default LoginForm;